// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SustainabilityRouteImport } from './routes/sustainability'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as EmiCalculatorRouteImport } from './routes/emi-calculator'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as PortfolioSlugRouteImport } from './routes/portfolio.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const SustainabilityRoute = SustainabilityRouteImport.update({
            id: '/sustainability',path: '/sustainability',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const EmiCalculatorRoute = EmiCalculatorRouteImport.update({
            id: '/emi-calculator',path: '/emi-calculator',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortfolioRoute
          })
const PortfolioSlugRoute = PortfolioSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => PortfolioRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const PortfolioRouteChildren = {
  PortfolioSlugRoute: PortfolioSlugRoute,PortfolioIndexRoute: PortfolioIndexRoute
}

const PortfolioRouteWithChildren = PortfolioRoute._addFileChildren(PortfolioRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,EmiCalculatorRoute: EmiCalculatorRoute,LegalRoute: LegalRoute,PortfolioRoute: PortfolioRouteWithChildren,PrivacyRoute: PrivacyRoute,ServicesRoute: ServicesRoute,SustainabilityRoute: SustainabilityRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)